import { render, staticRenderFns } from "./bale-stockorder.vue?vue&type=template&id=07bc3f5c&"
import script from "./bale-stockorder.vue?vue&type=script&lang=ts&"
export * from "./bale-stockorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports